import { ReactElement, useMemo } from 'react';
import { get } from 'lodash';

import {
  WhatsappTypeSelectorOptionStatusChipProps,
  WhatsappTypeSelectorOptionStatusChipTypeMapping,
} from './types';
import { WhatsappTypeSelectorOptionActionsStatusChip } from './styles';

const typeMapping: WhatsappTypeSelectorOptionStatusChipTypeMapping = {
  'not-available': {
    label: 'No disponible',
    color: 'tertiary',
  },
  connected: {
    label: 'Activo',
    color: 'success',
  },
  disconnected: {
    label: 'Desconectado',
    color: 'tertiary',
  },
};

const WhatsappTypeSelectorOptionStatusChip = ({
  type = 'not-available',
}: WhatsappTypeSelectorOptionStatusChipProps): ReactElement => {
  const currentTypeData = useMemo(() => get(typeMapping, type), [type]);

  return (
    <WhatsappTypeSelectorOptionActionsStatusChip
      variant="outlined"
      size="small"
      label={currentTypeData.label}
      color={currentTypeData.color}
    />
  );
};

export default WhatsappTypeSelectorOptionStatusChip;
